import "@common/jquery.ext";
import {ajax} from "@common/ajax";
import {menu} from "@common/menu";

$(() => {
    $("#csNm").enter("#email");
    $("#email").enter(doFindId);
    $("#btnSubmit").click(doFindId);
    $("#btnCancel, #btnLogin").click(menu.goLogin);
});

const doFindId = (): void => {
    // hide message
    hideMessage();

    // check valid
    if ($("#csNm").trim().val() === "") {
        showMessage("이름을 입력해 주세요.");
        $("#csNm").focus();
    }
    else if ($("#email").trim().val() === "") {
        showMessage("이메일을 입력해 주세요.");
        $("#email").focus();
    }
    else {
        ajax.formSubmit({
            url: "./findIdProc.do",
            form: "#frmFindId",
            func: {
                success: setFindIdResult,
                error: (result: any) => {
                    let message = ajax.getErrorMessage(result, [
                        { code: 1, message: "회원 정보를 찾을 수 없습니다." }
                    ]);
                    showMessage(message);
                }
            }
        });
    }
}

const setFindIdResult = (result: any): void => {
    if (!!result) {
        $(".find-result").html(result.mbrId);
        $("#atcFind").addClass("hide");
        $("#atcResult").removeClass("hide");
    }
}

const showMessage = (message: string): void => {
    $(".account-message").html(message).show();
}

const hideMessage = (): void => {
    $(".account-message").html("");
}

